import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
// styles
import { MessageControlled } from './messageControlled';
const MessageUnControlledComponent = ({ defaultOpen = true, ...props }, ref) => {
    const [open, setOpen] = React.useState(defaultOpen);
    const handleCloseButton = event => {
        setOpen(false);
        props.closeIcon?.onClick?.(event);
    };
    return (_jsx(MessageControlled, { ...props, ref: ref, closeIcon: props.closeIcon ? { ...props.closeIcon, onClick: handleCloseButton } : undefined, open: open }));
};
const MessageUnControlled = React.forwardRef(MessageUnControlledComponent);
export { MessageUnControlled };
export { MessageUnControlled as Message };
//# sourceMappingURL=messageUnControlled.js.map